import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';

interface ProjectsAlertStackProps {
  jiraConfigured?: boolean;
  error?: string;
  warning?: string;
  warningAction?: React.ReactNode;
}

const ProjectsAlertStack: React.FC<ProjectsAlertStackProps> = ({
  jiraConfigured = true,
  error,
  warning,
  warningAction,
}) => {
  const [dismissedJira, setDismissedJira] = useState(false);
  const [dismissedError, setDismissedError] = useState<string | null>(null);
  const [dismissedWarning, setDismissedWarning] = useState<string | null>(null);

  const showJira = !jiraConfigured && !dismissedJira;
  const showError = Boolean(error) && error !== dismissedError;
  const showWarning = Boolean(warning) && warning !== dismissedWarning;

  if (!showJira && !showError && !showWarning) {
    return null;
  }

  return (
    <>
      {showJira && (
        <Alert variant="warning" dismissible closeLabel="Fechar" onClose={() => setDismissedJira(true)}>
          Integração Jira não configurada no ambiente. Defina as variáveis de ambiente no backend e reinicie a API.
        </Alert>
      )}
      {showError && error && (
        <Alert variant="danger" dismissible closeLabel="Fechar" onClose={() => setDismissedError(error)}>
          {error}
        </Alert>
      )}
      {showWarning && warning && (
        <Alert variant="warning" dismissible closeLabel="Fechar" onClose={() => setDismissedWarning(warning)}>
          <div>{warning}</div>
          {warningAction}
        </Alert>
      )}
    </>
  );
};

export default ProjectsAlertStack;
